/* Shipping ETA pill countdown.

   Paired with snippets/sko-eta-box.liquid. The snippet renders the opening
   figure server-side and hands over an absolute target -- the epoch second of
   the next order cutoff, worked out in shop time -- so every visitor counts
   down to the same real moment whatever timezone they are in. This only keeps
   that figure ticking, and rolls it to the next cutoff once one passes. */
(function () {
  var DAY = 86400;

  if (customElements.get('sko-eta-countdown')) return;

  customElements.define(
    'sko-eta-countdown',
    class SkoEtaCountdown extends HTMLElement {
      connectedCallback() {
        this.countEl = this.querySelector('[data-eta-count]');
        this.target = parseInt(this.dataset.etaTarget, 10);

        if (!this.countEl || !this.target) return;

        this.tzOffset = parseInt(this.dataset.etaTzOffset, 10) || 0;
        this.skipWeekends = this.dataset.etaSkipWeekends === 'true';
        /* Not `this.style` -- that is the element's inline style, and
           assigning to it wipes every variable the snippet set there. */
        this.countStyle =this.dataset.etaStyle || 'auto';

        this.tick();
        this.timer = setInterval(this.tick.bind(this), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      /* Which weekday an epoch second falls on in the shop's timezone, 0 =
         Sunday. Shifting by the offset lets the UTC getter answer a shop-side
         question without pulling in a date library. */
      shopWeekday(epoch) {
        return new Date((epoch + this.tzOffset * 60) * 1000).getUTCDay();
      }

      /* Days the warehouse is shut, which a cutoff can never land on. */
      isClosed(epoch) {
        if (!this.skipWeekends) return false;

        var day = this.shopWeekday(epoch);
        return day === 0 || day === 6;
      }

      /* A cutoff that has been and gone becomes the next day's, stepping over
         any closed day so the pill never counts down to one. The guard keeps
         a bad target from spinning the loop. */
      rollTarget(now) {
        var guard = 0;

        while ((this.target <= now || this.isClosed(this.target)) && guard < 14) {
          this.target += DAY;
          guard += 1;
        }
      }

      tick() {
        var now = Math.floor(Date.now() / 1000);

        if (this.target <= now) this.rollTarget(now);

        var left = this.target - now;
        var hours = Math.floor(left / 3600);
        var minutes = Math.floor((left % 3600) / 60);
        var seconds = left % 60;

        /* On 'auto', seconds appear inside the last hour, where they read as
           urgency rather than noise. The other two settings are absolute. */
        var showSeconds = this.countStyle === 'seconds' || (this.countStyle === 'auto' && hours === 0);

        var text = hours > 0 ? hours + 'h ' + minutes + 'm' : minutes + 'm';
        if (showSeconds) text += ' ' + String(seconds).padStart(2, '0') + 's';

        if (this.countEl.textContent !== text) this.countEl.textContent = text;
      }
    }
  );
})();
